// Delegated quick-add for product cards. One listener covers every card on the
// page, including sections rendered later by the Section Rendering API.
(() => {
  const ADD_URL = '/cart/add.js';

  async function quickAdd(button) {
    const id = Number(button.dataset.variantId);
    if (!id || button.disabled) return;

    const label = button.querySelector('[data-quick-add-label]');
    const original = label.textContent;
    button.disabled = true;
    label.textContent = 'Adding…';

    try {
      const response = await fetch(ADD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      label.textContent = 'Added';
      button.classList.add('is-added');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      label.textContent = 'Try again';
    } finally {
      setTimeout(() => {
        label.textContent = original;
        button.classList.remove('is-added');
        button.disabled = false;
      }, 1800);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-quick-add]');
    if (!button) return;
    event.preventDefault();
    quickAdd(button);
  });
})();
